import action from '../../../abstract/action.js';
import ZusDeclarationPackageApi from '../../../../../api-v2/bookkeeping/zus-declarations-package.js';

export default action({
  label: 'Pobierz potwierdzenie przekazania',
  icon: 'PrinterIcon',
  main: () => false,
  render: ({ item }) => item.status === 'Przesyłka przyjęta do ZUS',
  handle: async ({reloadList, $vs, item}) => {
    $vs.loading();

    ZusDeclarationPackageApi.printConfirmationFromZus({ zuspackageId: item.id })
      .then(({ data: { url } }) => {
        const link = document.createElement('a');
        link.download = 'download';
        link.href = url;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      })
      .finally(() => {
        $vs.loading.close();
      });
  },
});
